import { FC, memo } from 'react'

import getProgressBarPoints from '@pepper/utils/src/function/getProgressBarPoints'
import styles from './_.module.css'
import ItemCount from './ItemCount'

interface Props {
  count: { [key in AssignmentStage]?: number }
}

const MIN_PERCENTAGE_VALUE = 0.2

const SpacedProgressBar: FC<Props> = ({ count }) => {
  //** function: for getting count values as widths for progress-bar percentages*/
  const progressBarPoints = getProgressBarPoints(count)
  const newInProgress =
    progressBarPoints?.newInProgressCount || MIN_PERCENTAGE_VALUE

  const approvalPending = progressBarPoints?.pending || MIN_PERCENTAGE_VALUE

  const approved = progressBarPoints?.completed || MIN_PERCENTAGE_VALUE

  const pepperDocCount = 0.2

  const total = newInProgress + approvalPending + approved + pepperDocCount

  return (
    <div className={styles.spacedProgressBar}>
      <div className={styles.svgEl}>
        <ItemCount
          totalCount={total}
          countsByStage={{
            newInProgress,
            approvalPending: newInProgress + approvalPending,
            approved: newInProgress + approvalPending + approved,
            docCount:
              newInProgress + approvalPending + approved + pepperDocCount,
          }}
        />
      </div>
    </div>
  )
}

export default memo(SpacedProgressBar)
